import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  phone: string;
  email: string;
}

export const InfoSection = ({ phone, email }: Props) => {
  return (
    <ContactSection>
      <TextLink href={`tel:${phone}`}>
        <SvgIcon
          icon={IconType.phone}
          alt={__('Telefón')}
          width={16}
          height={16}
          marginRight={8}
          fill={'black'}
          cursor="pointer"
          viewBox="0 0 16 16"
        />
        Tel.: {phone}
      </TextLink>
      <TextLink href={`mailto:${email}`}>
        <SvgIcon
          icon={IconType.email}
          alt={__('Odoslať na email')}
          width={16}
          height={16}
          marginRight={8}
          fill={'black'}
          cursor="pointer"
          viewBox="0 0 16 16"
        />
        Email: {email}
      </TextLink>
    </ContactSection>
  );
};

const ContactSection = styled.div`
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: ${rem(16)};

  svg {
    fill: ${({ theme }) => theme.colors.tertiary} !important;
  }
`;

const TextLink = styled.a`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(13)};
  line-height: ${rem(17)};
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  margin-right: ${rem(16)};

  &:hover {
    text-decoration: underline;
  }
`;
